import React from 'react';

import { ISVGPersonalProps } from 'types/svg';

export const draft: ISVGPersonalProps = {
  viewBox: '0 0 28 28',
  content: (
    <g id="draft_icon" data-name="draft icon" transform="translate(18460.398 2947.654)">
      <rect
        id="Rectangle_2788"
        data-name="Rectangle 2788"
        width="28"
        height="28"
        transform="translate(-18460.398 -2947.654)"
        fill="none"
      />
      <g id="Group_4366" data-name="Group 4366">
        <path
          id="Path_7214"
          data-name="Path 7214"
          d="M2.047,19.1h12.28a2.047,2.047,0,0,0,2.047-2.047V2.047A2.047,2.047,0,0,0,14.327,0H7.388A2.047,2.047,0,0,0,5.942.6L.6,5.942A2.047,2.047,0,0,0,0,7.388v9.667A2.047,2.047,0,0,0,2.047,19.1M15.009,2.047V17.055a.682.682,0,0,1-.682.682H2.047a.682.682,0,0,1-.682-.682V7.5H5.458A2.047,2.047,0,0,0,7.5,5.458V1.364h6.822a.682.682,0,0,1,.682.682m-8.869.28V5.458a.682.682,0,0,1-.682.682H2.326Z"
          transform="translate(-18454.564 -2943.541)"
          fill="currentColor"
        />
        <path
          id="Path_7215"
          data-name="Path 7215"
          d="M4.682,14a.682.682,0,1,0,0,1.364h9.551a.682.682,0,1,0,0-1.364Z"
          transform="translate(-18455.836 -2947.989)"
          fill="currentColor"
        />
        <path
          id="Path_7216"
          data-name="Path 7216"
          d="M14.233,19H4.682a.682.682,0,0,0,0,1.364h9.551a.682.682,0,1,0,0-1.364"
          transform="translate(-18455.836 -2949.578)"
          fill="currentColor"
        />
      </g>
    </g>
  ),
};
